// Render an amount + unit for display: no space before pure weight/volume units
// ("10g", "250ml"), a single space otherwise ("9 eggs", "1 can"). Returns '' when
// there's nothing to show.
const NO_SPACE_UNITS = new Set(['g', 'kg', 'mg', 'ml', 'cl', 'l', 'oz', 'lb', '%']);

export function formatAmountUnit(amount, unit) {
  if (amount == null || amount === '' || Number.isNaN(Number(amount))) return '';
  const u = String(unit || '').trim();
  if (!u) return String(amount);
  return NO_SPACE_UNITS.has(u.toLowerCase()) ? `${amount}${u}` : `${amount} ${u}`;
}
